module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hant_1-968f4d5a3c882566f6cf830531416f57.jpg";